import { Component, EventEmitter, Output } from '@angular/core';
import { NavigationService } from 'src/app/core/navigation.service';

@Component({
  selector: 'app-buyer-details-navbar',
  templateUrl: './buyer-details-navbar.component.html',
  styleUrls: ['./buyer-details-navbar.component.scss'],
})
export class BuyerDetailsNavbarComponent {
  @Output() tab_change: EventEmitter<string> = new EventEmitter<string>();

  tabs = this.navigation_service.navigation_set.buyer_details_tabs;
  current_tab = this.tabs.get('article');

  constructor(private navigation_service: NavigationService) {}

  onTabClick(tab: string[]): void {
    this.current_tab = this.tabs.get(tab[0]);
    this.tab_change.emit(this.current_tab);
  }

  getTabs(): string[][] {
    return [...this.tabs];
  }
}
